import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderComponent } from '@sirius/common';
import { InfoBoxComponent } from '../info-box/info-box.component';
import { MatchmakingTranslateService } from 'matchmaking/services';
import { InterpolatePipe } from 'shared/pipes';
import { KEY_BENEFITS } from 'matchmaking/constants';

@Component({
    selector: 'matchmaking-key-benefits',
    imports: [CommonModule, InfoBoxComponent, InterpolatePipe, SliderComponent],
    templateUrl: './key-benefits.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './key-benefits.component.scss'
})
export class KeyBenefitsComponent {
    translateService = inject(MatchmakingTranslateService);

    application = input('');

    translations = computed(() => this.translateService.translations());
    benefits = computed(() => KEY_BENEFITS);

    getTranslation(key: string) {
        return this.translateService.getTranslation(key);
    }
}
